import * as React from "react";
import {
  Checkbox,
  Card,
  CardBody,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";

interface NFTBoxProps {
  image: string;
  id: number;
  checked: boolean;
  onCheck: (id: number) => void;
}

export const NFTBox: React.FC<NFTBoxProps> = ({
  image,
  id,
  checked,
  onCheck,
}) => {
  return (
    <Card rounded={"md"}>
      <CardBody>
        <VStack alignItems={"center"}>
          <img
            src={image}
            style={{
              borderRadius: "5px",
            }}
            alt="NFT"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src =
                "https://removal.ai/wp-content/uploads/2021/02/no-img.png";
            }}
          />
          <HStack justifyContent={"center"}>
            <Checkbox
              size="lg"
              isChecked={checked}
              onChange={() => onCheck(id)}
            />
            <Text fontSize={"lg"}>#{id}</Text>
          </HStack>
        </VStack>
      </CardBody>
    </Card>
  );
};
